function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { expVal } from '../../../expVal';

// Batched mutation data for performance optimization

function createMutationObserver(_ref) {
  var onAttributeMutation = _ref.onAttributeMutation,
    onChildListMutation = _ref.onChildListMutation,
    onMutationFinished = _ref.onMutationFinished;
  if (!window || typeof window.IntersectionObserver !== 'function') {
    return null;
  }
  var mutationObserverCallback = function mutationObserverCallback(mutations) {
    var targets = [];
    // Use nested Maps for O(1) batching performance
    // Short-lived Maps are safe since they're discarded after each callback
    var batchedMutations = new Map();
    var _iterator = _createForOfIteratorHelper(mutations),
      _step;
    try {
      var _loop = function _loop() {
          var mut = _step.value;
          if (!(mut.target instanceof HTMLElement)) {
            return 0; // continue
          }
          if (expVal('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
            // Intended for excluding out of band mutations such as tooltips on hover, and page flags
            // Currently being tested in Confluence
            // Skip elements with data-vc-oob attribute
            if (mut.target.dataset.vcOob) {
              return {
                v: void 0
              };
            }
          }
          if (mut.type === 'attributes') {
            var _mut$oldValue;
            /*
            			"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            			I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            			Conceptually there is after all a mutation: there is an old value replaced with a new one,
            			and whether or not they are the same doesn't really matter.
            			And Custom elements should work the same way as MutationObserver."
            			https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            		*/
            var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
            var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
            if (oldValue !== newValue) {
              var _mut$attributeName;
              onAttributeMutation({
                target: mut.target,
                attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown',
                oldValue: oldValue,
                newValue: newValue
              });
            }
            return 0; // continue
          } else if (mut.type === 'childList') {
            var _mut$addedNodes, _mut$removedNodes;
            // In chromium browser MutationRecord has timestamp field, which we should use.
            var timestamp = Math.round(mut.timestamp || performance.now());

            // Get or create timestamp bucket
            var timestampBucket = batchedMutations.get(timestamp);
            if (!timestampBucket) {
              timestampBucket = new Map();
              batchedMutations.set(timestamp, timestampBucket);
            }

            // Get or create target batch within timestamp bucket
            var batch = timestampBucket.get(mut.target);
            if (!batch) {
              batch = {
                target: new WeakRef(mut.target),
                addedNodes: [],
                removedNodes: [],
                timestamp: timestamp
              };
              timestampBucket.set(mut.target, batch);
            }

            // Accumulate added nodes
            ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function (node) {
              if (node instanceof HTMLElement) {
                batch.addedNodes.push(new WeakRef(node));
              }
            });

            // Accumulate removed nodes
            ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function (node) {
              if (node instanceof HTMLElement) {
                batch.removedNodes.push(new WeakRef(node));
              }
            });
          }
          targets.push(mut.target);
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret === 0) continue;
        if (_ret) return _ret.v;
      }

      // Process all batched childList mutations
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(batchedMutations.values()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var timestampBucket = _step2.value;
        var _iterator3 = _createForOfIteratorHelper(timestampBucket.values()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var batch = _step3.value;
            onChildListMutation({
              target: batch.target,
              addedNodes: batch.addedNodes,
              removedNodes: batch.removedNodes,
              timestamp: batch.timestamp
            });
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
      targets: targets
    });
  };
  var observer = new MutationObserver(mutationObserverCallback);
  return observer;
}
export default createMutationObserver;